import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobileForwardMail = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M729.966 64h-436.367c-48 0-86.837 39.273-86.837 87.273v785.454c0 48 38.837 87.273 86.837 87.273h436.367c48 0 87.273-39.273 87.273-87.273v-785.454c0-48-39.273-87.273-87.273-87.273zM729.966 849.454h-436.367v-610.908h436.367v610.908zM546.695 597.237v76.367l122.619-114.327c9.167-8.727 9.167-23.127 0-31.854l-122.619-114.327v74.181c-135.708 18.767-189.819 111.708-209.454 205.092 48.437-65.454 112.581-95.127 209.454-95.127z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMobileForwardMail);
export default ForwardRef;
